import React from "react";
import { Navigate } from "react-router-dom";
import useAuthStudent from "../hooks/useAuthStudent";

export default function PublicRoutes({ children }) {
  const isLoggedIn = useAuthStudent();
  return !isLoggedIn ? children : <Navigate to="/coursePlayer" />;
}
